import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { APP } from 'app/AppRoutes';
import ContactSupportForm from './support.form';

const ContactSupportModal: React.FC<{}> = () => {
  const [error, setError] = useState<null | string>(null);

  return ReactDOM.createPortal(
    <ContactSupportForm formError={error} setError={setError} />,
    document.querySelector(`#${APP}`) || document.body
  );
};

ContactSupportModal.displayName = 'ContactSupportModal';
export default ContactSupportModal;
